import React from "react";
import { Table } from "antd";
import { Modal } from "antd";
import styled from "styled-components";
import I18n from "../../i18n";
import store from "../../reducers/";
import { CallChannels, Sessions } from "../../util/appointments";
import { isAlive } from "../../util/index";
import moment from "moment";

const TableHeader = styled.div`
    color: ${props => props.color};
`;
const TextWordBreak = styled.div`
    word-break: break-word;
    ${props => props.capitalize ? `
        text-transform: capitalize;
    ` : ""}
`;
const times = {
	second: I18n.t("time.second.short"),
	minute: I18n.t("time.minute.short")
};
function durationToTime(duration) {
	let buff_duration = duration;
	if (!Number.isInteger(buff_duration)) {
		buff_duration = buff_duration.toFixed(2);
	}
	return `${buff_duration} ${times.minute}`;
}
function appointmentsToTableData(appointments = []) {
	const timeFormat = "YYYY-MM-DD HH:mm:ss";
	const unknownDate = I18n.t("unknown_date");
	const unknownDuration = I18n.t("unknown_duration");
	const outDatas = [];
	if (isAlive(appointments)) {
		const sortedAppointments = appointments.sort((a,b)=>b.created-a.created);
		for (let i = 0; i < sortedAppointments.length; i += 1) {
			const {
				call_channel,
				status,
				reserved_duration,
				price_detail,
				created,
				start
			} = sortedAppointments[i];
			let duration = unknownDuration;
			if (isAlive(price_detail)) {
				duration = durationToTime(price_detail.duration);
			} else if (isAlive(reserved_duration)) {
				duration = durationToTime(reserved_duration);
			}
			const convert_created = created ? moment(created,"X").format(timeFormat) : unknownDate;
			const convert_start = start ? moment(start,"X").format(timeFormat) : unknownDate;
			outDatas.push({ key: `${i}`, call_channel, status, duration, created:convert_created, start:convert_start});
		}
	}
	return outDatas;
}
const buildColumns = (color) => {
	return [{
		title: <TableHeader color={color}>{I18n.t("session_activity_log.titles.recent_activity")}</TableHeader>,
		render: (type) => <TextWordBreak>{CallChannels[type]}</TextWordBreak>,
		dataIndex: "call_channel",
		width: 120,
		key: "call_channel",
	}, {
		title: <TableHeader color={color}>{I18n.t("session_activity_log.titles.status")}</TableHeader>,
		render: (text) => <TextWordBreak capitalize>{text}</TextWordBreak>,
		dataIndex: "status",
		width: 100,
		key: "status",
	}, {
		title: <TableHeader color={color}>{I18n.t("session_activity_log.titles.created")}</TableHeader>,
		render: (text) => <TextWordBreak>{text}</TextWordBreak>,
		dataIndex: "created",
		key: "created",
	},{
		title: <TableHeader color={color}>{I18n.t("session_activity_log.titles.start")}</TableHeader>,
		render: (text) => <TextWordBreak>{text}</TextWordBreak>,
		dataIndex: "start",
		key: "start",
	}, {
		title: <TableHeader color={color}>{I18n.t("session_activity_log.titles.duration")}</TableHeader>,
		render: (text) => <TextWordBreak>{text}</TextWordBreak>,
		width:100,
		dataIndex: "duration",
		key: "duration",
	}];
};

const LogsTable = ({ header, r, dataSource }) => {
	const { color } = store.getState().organization.organization;
	return (
		<Table
			title={() => header}
			footer={() => r ? <a onClick={() => r.showModal()}
				style={{ textAlign: "center", color }}>{I18n.t("load_more")}</a> : null}
			dataSource={dataSource.length > 4 && r ? dataSource.slice(0, 4) : dataSource}
			columns={buildColumns(color)}
			size="small"
			pagination={!r} />
	);
};

class ModalSessionActivityLog extends React.Component {
    state = { visible: false }
    showModal = () => {
    	this.setState({
    		visible: true,
    	});
    }
    handleOk = (e) => {
    	this.setState({
    		visible: false,
    	});
    }
    handleCancel = (e) => {
    	this.setState({
    		visible: false,
    	});
    }
    render() {
    	const { header, dataSource, width = 800 } = this.props;
    	return (
    		<Modal
    			title={header}
    			visible={this.state.visible}
    			onOk={this.handleOk}
    			onCancel={this.handleCancel}
    			width={`${width}px`}
    			footer={null}
    		>
    			<LogsTable header={header} dataSource={dataSource} />
    		</Modal>
    	);
    }
}

class SessionActivityLog extends React.Component {
    bakeAppointments = [];
    texts = [];
    constructor(props) {
    	super(props);
    	// console.log('new date: ',new Date());
    	this.texts = {
    		header: I18n.t("session_activity_log.header"),
    	};
    	const { appointments } = props;
    	this.bakeAppointments = appointmentsToTableData(appointments);
    }
    componentWillReceiveProps(props) {
    	const { appointments } = props;
    	this.bakeAppointments = appointmentsToTableData(appointments);
    }
    render() {
    	return (
    		<div>
    			<LogsTable
    				r={this.refs.modal}
    				header={this.texts.header}
    				dataSource={this.bakeAppointments}
    			/>
    			<ModalSessionActivityLog ref='modal'
    				header={this.texts.header}
    				dataSource={this.bakeAppointments}
    			/>
    		</div>
    	);
    }
}
SessionActivityLog.defaultProps = {
	dataSource: [],
	showSessions: Object.values(Sessions).slice(1),
};
export default SessionActivityLog;


// WEBPACK FOOTER //
// ./src/components/home/SessionActivityLog.js